// extracted by mini-css-extract-plugin
export default {"item":"item--Hj9zL","markerAnimationScale":"markerAnimationScale--VxF8G"};